/*
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-07 10:16:07
 * @LastEditors: luckymiaow
 * @LastEditTime: 2023-06-19 09:13:47
 */

import type { VNode } from 'vue';
import type { SelectProps } from 'ant-design-vue';
import type { FieldNames as AFieldNames } from 'ant-design-vue/lib/vc-select/Select';
import type { LabeledValue as ALabeledValue } from 'ant-design-vue/lib/select';
import type { FormConfig } from '../form/types';

export interface OptionsItem<T> {
  label: string | number;
  value: string | number;
  disabled?: boolean;
  data?: T;
  options?: OptionsItem<T>;
}

export type Api = (params: any) => Promise<OptionsItem<unknown>[]>;

export class FieldNames implements AFieldNames {
  label = 'label';
  value = 'value';
  options = 'options';
}

export interface LabeledValue<T> extends ALabeledValue {
  readonly data?: T[];
}

export interface ISelectProps extends SelectProps, FormConfig {
  fieldNames?: AFieldNames;

  // insertOptions?: LabeledValue<unknown>[]; // 插入选项 以做回显
  insertOptions?: unknown[]; // 插入选项 以做回显

  selectedFirst?: boolean; // 是否默认选中第一条

  nullValue?: any; // 指定数据为null
}

export interface ISelectApiProps extends SelectProps, FormConfig {
  api?: Api;

  params?: object; // 接口参数 此属性改变时会自动重新加载接口数据

  fieldNames?: FieldNames; // label显示文本 value实际值字段

  immediate?: boolean; // 是否立即加载数据 默认false
}

export interface OptionNode {
  value: string | number;
  label: string | number;
  data?: unknown;
  node: VNode | string | number;
}
